export const ABSENCE_TYPES = [
  'Vacation',
  'CarriedOverVacation',
  'SelfCertifiedSickLeave',
  'CertifiedSickLeaveUpTo16Days',
  'CertifiedSickLeaveOver16Days',
  'SickChildLeave',
  'SickLeaveWithoutPay',
  'CareBenefitLeave',
  'PregnancyBenefitLeave',
  'TrainingBenefitLeave',
  'ParentalBenefitLeave',
  'WorkAssessmentAllowanceLeave',
  'WelfareLeave',
  'PaidLeave',
  'UnpaidLeave',
  'TimeOffInLieu',
  'NegativeTimeBank'
] as const;

export type AbsenceType = (typeof ABSENCE_TYPES)[number];

export const ABSENCE_TYPE_TRANSLATION_KEYS: Record<AbsenceType, string> = {
  Vacation: 'time-report-absence-type-vacation',
  CarriedOverVacation: 'time-report-absence-type-carried_over_vacation',
  SelfCertifiedSickLeave: 'time-report-absence-type-self_certified_sick_leave',
  CertifiedSickLeaveUpTo16Days: 'time-report-absence-type-certified_sick_leave_up_to_16_days',
  CertifiedSickLeaveOver16Days: 'time-report-absence-type-certified_sick_leave_over_16_days',
  SickChildLeave: 'time-report-absence-type-sick_child_leave',
  SickLeaveWithoutPay: 'time-report-absence-type-sick_leave_without_pay',
  CareBenefitLeave: 'time-report-absence-type-care_benefit_leave',
  PregnancyBenefitLeave: 'time-report-absence-type-pregnancy_benefit_leave',
  TrainingBenefitLeave: 'time-report-absence-type-training_benefit_leave',
  ParentalBenefitLeave: 'time-report-absence-type-parental_benefit_leave',
  WorkAssessmentAllowanceLeave: 'time-report-absence-type-work_assessment_allowance_leave',
  WelfareLeave: 'time-report-absence-type-welfare_leave',
  PaidLeave: 'time-report-absence-type-paid_leave',
  UnpaidLeave: 'time-report-absence-type-unpaid_leave',
  TimeOffInLieu: 'time-report-absence-type-time_off_in_lieu',
  NegativeTimeBank: 'time-report-absence-type-negative_time_bank'
};
